/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ValidationRule {
  id: string;
  message: string;
  type: string;
  isValid: boolean;
  pageId?: string;
}

export interface ValidationState {
  rules: ValidationRule[];
}

const initialState: ValidationState = {
  rules: [],
};

const validationSlice = createSlice({
  name: 'validation',
  initialState,
  reducers: {
    addValidation: (state, action: PayloadAction<ValidationRule>) => {
      if (!state.rules.some((rule) => rule.id === action.payload.id)) {
        state.rules.push(action.payload);
      }
    },
    removeValidation: (state, action: PayloadAction<string>) => {
      state.rules = state.rules.filter((rule) => rule.id !== action.payload);
    },
    clearValidation: (state) => {
      state.rules = [];
    },
  },
});

export const { addValidation, removeValidation, clearValidation } = validationSlice.actions;
export default validationSlice.reducer;
